import { IconStyled, TextFieldStyled } from '@procurify/ui'
import styled from 'styled-components'

interface IExporterColumnTextFieldStyledProps {}

export const ExporterColumnTextFieldStyled = styled.div<IExporterColumnTextFieldStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  ${TextFieldStyled} {
    .input {
      font-size: ${(props) => props.theme.typography.pxToRem(12)};

      border-color: transparent;

      &.inputFocused {
        border-color: ${(props) => props.theme.colors.darkGreen};
      }

      .nativeInput {
        padding: 0.5em;
      }
    }
  }

  .textfield-editicon {
    height: ${(props) => props.theme.typography.pxToRem(38)};
    padding: 0 ${(props) => props.theme.typography.pxToRem(4)};

    display: flex;
    align-items: center;
    background-color: transparent;
    border-color: transparent;

    cursor: pointer;

    &:hover {
      > ${IconStyled} {
        color: ${(props) => props.theme.colors.darkGreen};
      }
    }
  }
`
